export default __webpack_public_path__ + "static/media/dieppe.507a1106.jpg";